import { Text as SambaText } from '@betterment/samba-react';

interface Props {
  children: React.ReactNode;
}

export function Subtext(props: Props) {
  const { children, ...restProps } = props;
  return (
    <SambaText variant="text25" css={{ color: 'primitives.white.100alpha60' }} {...restProps}>
      {children}
    </SambaText>
  );
}

Subtext.displayName = 'Nav.Subtext';
